/** @ignore *//** */

import { firestore } from "firebase";

export interface Ingredient {
  /** Reference identifier from the registry database */
  reference: string;
  inciName: string;
  innName: string;
  phEurName: string;
  /** CosIng is the European Commission database for information on cosmetic substances and ingredients contained in the */
  casNumber: string;
  /** Cosmetics Regulation (EC) number */
  cosingRef: number;
  /** Cosmetics Regulation (EC) number */
  ecNumber: string;
  /** IUPAC: International Union of Pure and Applied Chemistry */
  iupacName: string;
  function: string;
  restriction: string;
  /** Date when the ingredient was updated from the registry database */
  updateDate: Date;
  /** @hidden */
  evaluationId: null | string;
  /** @hidden */
  hasAssessment: boolean;
  /** @hidden */
  hasEvaluation: boolean;
}

export interface IngredientProject extends Ingredient {
  /** @hidden */
  ref: firestore.DocumentReference; // self
  /** @hidden */
  doc: firestore.DocumentSnapshot; // self
  /** @hidden */
  id: string;
  /** @hidden */
  companyId: string;
  /** @hidden */
  projectId: string;
  /** User defined assessment */
  assessment: string;
  /** User defined Dermal Absoroption % */
  dermalAbsorptionPcnt: number;
  /** CLP */
  clp: string;
  /** NOAEL: No Observed Adverse Effect Level */
  noael: string;
  /** Evaluated restriction */
  evaluatedRestriction: string;
  /** Date when the ingredient assessment was made */
  added: Date;
  /** Date when the ingredient assessment was updated */
  updated: Date;
  /** @hidden */
  custom: boolean | null;
}

/** @hidden */
export const ingredientVariables = [
  'inciName',
  'innName',
  'phEurName',
  'casNumber',
  'cosingRef',
  'ecNumber',
  'iupacName',
  'function',
  'restriction',
  'assessment',
  'dermalAbsorptionPcnt',
  'clp',
  'noael',
]


export default Ingredient